export default __webpack_public_path__ + "media/images/33-0d7b7964f09db269e7459e07bab5707c.png";